<a [ngClass]="getItemClass()" href="{{item.url}}">
  <i *ngIf="helper.hasIcon(item)" [ngClass]="getLabelIconClass()"></i>
  <ng-container>{{item.id}}</ng-container>
  <span *ngIf="helper.hasBadge(item)" [ngClass]="helper.getBadgeClass(item)">{{ item.badge.text }}</span>
</a>
